import { BaseEntity } from '../../../xform-compat';
import { CompanyBasic } from './company-basic.model';
import { SpaceTotals } from './space-totals.model';
import { ReferenceStyle } from '../reference-style';


export class CompanySpace implements BaseEntity {
  id: number;
  name: string;
  active: boolean;
  isDefault: boolean;
  company: CompanyBasic;
  totals: SpaceTotals;
  displayConfirmDelete: boolean;
  isItemSelected?: boolean;
  displayName?: string;
  companyId?: number;
  style: Partial<ReferenceStyle>;

  constructor (space: any = {}) {
    this.id = space.id || -1;
    this.name = '';
    this.isDefault = space.isDefault || false;
    this.company = space.company || null;
    this.totals = space.totals || new SpaceTotals();
    this.displayConfirmDelete = space.displayConfirmDelete || false;
    this.isItemSelected = space.isItemSelected || false;
    this.displayName = space.displayName || `${space.company ? space.company.name : ''} ${!space.isDefault ? '(' + space.name + ')' : ''}`;
  }
}
